import {
  GET_ALL_MACHINE_LEARNING_TAGS,
  GET_ALL_METADATA,
  GET_METADATA,
  LOADING_METADATA,
  ERROR_METADATA,
  ADD_METADATA,
  UPDATE_METADATA,
  DELETE_METADATA,
  ADD_ML_TAG
} from "store/actions/metadataAction";

export default (state = {}, action) => {
  switch (action.type) {
    case LOADING_METADATA:
      return {
        ...state,
        isLoadingMetadata: action.payload
      };
    case ERROR_METADATA:
      return {
        ...state,
        errorMetadata: action.payload
      };
    case GET_ALL_MACHINE_LEARNING_TAGS:
      return {
        ...state,
        getAllMachineLearningTags: action.payload
      };
    case GET_ALL_METADATA:
      return {
        ...state,
        getAllMetadata: action.payload
      };
    case GET_METADATA:
      return {
        ...state,
        getMetadata: action.payload
      };
    case ADD_METADATA:
      return {
        ...state,
        addMetadata: action.payload
      };
    case UPDATE_METADATA:
      return {
        ...state,
        updateMetadata: action.payload
      };
    case DELETE_METADATA:
      return {
        ...state,
        deleteMetadataStatus: action.payload
      };
    case ADD_ML_TAG:
      return {
        ...state,
        addMachineLearningLabel: action.payload
      };
    default:
      return state;
  }
};
